<template>
  <div class="flex flex-col gap-0.5 leading-tight">
    <div class="font-semibold">
      <span v-if="props.data.UnitReference">{{ props.data.UnitReference }}</span>
      <span v-else class="italic text-gray-400">Unit {{ props.data.Id }}</span>
      <span v-if="props.data.Id" class="ml-1 font-normal text-gray-400">
        (Unit {{ props.data.Id }})
      </span>
    </div>

    <div v-if="props.data.ComplexDescription" class="text-sm text-gray-500">
      Building: {{ props.data.ComplexDescription }}
    </div>

    <div v-if="ownerName" class="text-sm text-gray-400">
      Owner: {{ ownerName }}
      <span v-if="props.data.OwnerId">({{ props.data.OwnerId }})</span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface AuxInputProps {
  data: any;
}

const props = defineProps<AuxInputProps>();

// unit_view exposes OwnerNames (plural) and OwnerSurname - there is no OwnerName column.
const ownerName = computed(() =>
  [props.data?.OwnerNames, props.data?.OwnerSurname]
    .filter(Boolean)
    .join(" ")
    .trim()
);
</script>

<style scoped></style>
